import { tools } from '@wenjuan/business'
import { httpMemberPackageInfo } from '@/api/common.js'
// 创建用户

export class Created {
  constructor(props) {
    this.name = props?.name || 'CreatedTest'
    this.data = function () {
      return {
        isMobile: false,
      }
    }
  }

  methods = {
    onDragend(ev) {
      ev.stopPropagation()
      const { x, y } = ev
      Object.assign(ev.target.style, { top: y + 'px', left: x + 'px', bottom: 'unset' })
    },
  }
}

// 创建集合对象
export class DefineConfig {
  constructor({ name, list, click, ...others } = {}) {
    this.name = name
    this.data = function () {
      return {
        list,
        click,
      }
    }
    Object.assign(this, others)
  }
}

// 创建模拟对象
export class MicroApp {
  name = 'SetMicro'

  data = function () {
    return {
      isMobile: false,
      list: [
        { label: '微应用', id: 'isWAUser', active: false },
        { label: '钉钉', id: 'isDingTalk', active: false },
        { label: '飞书', id: 'isFeishu', active: false },
        { label: '企业微信', id: 'isWxwork', active: false },
        { label: '试用版', id: 'isFreeTry', active: false },
        { label: '接口调式', id: 'api', active: false },
        { label: '查看数据', id: 'data', active: false },
      ],
    }
  }

  computed = {
    microApp() {
      return tools.$ENV.defineState()
    },
  }

  methods = {
    click(data) {
      if (data.id === 'data') {
        const { isWAUser, isWeixin, isWxwork, isDingTalk, isFeishu, version } = this.microApp
        window.alert(
          `当前版本：${version}\n微应用-${
            isWAUser || false
          }\n企业微信-${isWxwork}\n钉钉-${isDingTalk}\n飞书-${isFeishu}\nUA头信息:${window.navigator.userAgent}`
        )
        return
      }
      const mapList = ['isDingTalk', 'isFeishu', 'isWxwork']
      const changeOther = {}
      mapList.forEach((item) => {
        if (item !== data.id) changeOther[item] = false
      })
      // 微应用判断账号
      if (data.id === 'isWAUser') {
        data.active = !!this.microApp.isWAUser
        const index = mapList.indexOf(this.microApp.isWAUser)
        changeOther.isWAUser = index === 2 ? '' : index === -1 ? 'isDingTalk' : mapList[index + 1]
      }
      if (data.id === 'api') {
        this.httpMemberPackageInfo()
        data.active = true
      }
      this.$store.commit('setDevRoles', { [data.id]: !this.microApp[data.id], ...changeOther })
      console.log(this.microApp)
    },

    httpMemberPackageInfo() {
      httpMemberPackageInfo()
        .then((res) => {
          console.log(res)
        })
        .catch((err) => err)
    },
  }
}

// 市场大赛
export const CSSC = {
  list: [{ label: '切换数据', id: 'test', active: false }],
  click(item) {
    if (window.$test) window.$test()
    item.active = !item.active
    // this.$store.commit('setTest', {
    //   name: 'asd',
    //   mobile: '15962463156',
    //   code: '2222',
    //   companyName: '32323',
    //   email: '4343@qq.com',
    // })
  },
}
